export default "/assets/images/purely-white-sm.jpg?3769d0899ae7cdd9037bb3a4f4052092";